import { onlyISODate } from '../../../libs/dates';
import axios from '../../../libs/cifra/axios';

function urlBaseCuaderno(id) {
  return `/api_publica/v1/cuadernos/asistencias/${id}`;
}

export default {
  infoCuaderno(idCuaderno, fecha, idHorario, admin, options) {
    const opts = options || {};
    const defaultParams = {
      fecha: onlyISODate(fecha),
      horario_id: idHorario,
      admin: admin === true ? true : undefined,
    };
    opts.params = Object.assign(defaultParams, opts.params);
    return axios.get(`${urlBaseCuaderno(idCuaderno)}/info`, opts);
  },
  pasarLista(datos, admin, options) {
    const id = datos.id || datos.cuaderno_id;
    const json = {
      evaluacion_id: datos.evaluacion_id,
      fecha: onlyISODate(datos.fecha),
      horario_id: datos.horario_id,
      pasar_lista: datos,
      admin: admin === true ? true : undefined,
    };
    return axios.post(`${urlBaseCuaderno(id)}/pasar_lista`, json, options);
  },
  estadisticasAlumno(idCuaderno, idAlumno, fecha, admin, options) {
    const soloFecha = onlyISODate(fecha);
    const opts = options || {};
    const defaultParams = {
      admin: admin === true ? true : undefined,
    };
    opts.params = Object.assign(defaultParams, opts.params);
    return axios.get(`${urlBaseCuaderno(idCuaderno)}/estadistica/${idAlumno}/${soloFecha}`, opts);
  },
};
